import { ENDPOINTS } from "../ApiConstants";
import { GET } from "../method";

export const bannerData = async () => {
    const url = ENDPOINTS.BANNER_URL
    return GET(url);
}

export const whatsNewData = async (id) => {
    const url = ENDPOINTS.WHATSNEW_URL(id)
    return GET(url);
}

export const popularCategoriesData = async (id) => {
    const url = ENDPOINTS.POPULAR_CATEGORIES_URL(id)
    return GET(url);
}

export const footerStatData = async () => {
    const url = ENDPOINTS.FOOTER_STAT_URL
    return GET(url);
}

export const publicRewardsData = async (id) => {
    const url = ENDPOINTS.PUBLIC_REWARDS_URL(id)
    return GET(url);
}

export const getGlobalSearch = async (id) => {
    const url = ENDPOINTS.GLOBAL_SEARCH(id);
    return GET(url);
}

export const getPublicSubModule = async (id) => {
    const url = ENDPOINTS.INTEGRATOR_INFO(id);
    return GET(url);
}

export const getPrivateSubModule = async (id) => {
    const url = ENDPOINTS.PRIVATE_SUBMODULE(id);
    return GET(url);
}

export const getPublicModule = async (id) => {
    const url = ENDPOINTS.PUBLIC_MODULE(id);
    return GET(url);
}

export const getWebsiteInfo = async () => {
    const url = ENDPOINTS.WEBSITE_INFO;
    return GET(url);
}

export const getWebsiteHeaderInfo = async () => {
    const url = ENDPOINTS.WEBSITE_HEADER_INFO;
    return GET(url);
}

export const getWebsiteLandingInfo = async (id) => {
    const url = ENDPOINTS.WEBSITE_LANDING_INFO(id);
    return GET(url);
}

export const getWebsiteRewardLisitingInfo = async (id) => {
    const url = ENDPOINTS.WEBSITE_REWARD_LISTING_INFO(id);
    return GET(url);
};

export const getGeneralWebsiteConfig = async (config) => {
    const url = ENDPOINTS.GENERAL_WEBSITE_CONFIG(config);
    return GET(url);
};
